import { JobDataTypes, CandidateDataTypes } from '@/constants/DataTypes';

export function validateFullName(fullName) {
  const trimmedName = fullName.trim();
  const nameParts = trimmedName.split(/\s+/);
  return nameParts.length >= 2;
}

export function validateEmail(input) {
  const reg = new RegExp(
    '^\\w+[\\w-\\.]*\\@\\w+((-\\w+)|(\\w*))\\.[a-z0-9|.]{2,20}$',
  );
  return reg.test(input.trim());
}

export function validatePhone(phone, mandatoryCountryCode) {
  // Clean the phone number by trimming spaces and removing spaces, dashes, and periods
  const cleanedPhone = phone.trim().replace(/[\s.-]/g, '');

  // Regular expression to match a valid phone number
  // This assumes country codes are in the format "+123" or "+12"
  const phoneRegexWithCountryCode = /^\+\d{1,3}\d{8,15}$/; // Country code with 1-3 digits followed by 8 to 15 digits
  const phoneRegexWithoutCountryCode = /^\d{8,15}$/; // Valid local phone number (without a country code) with 8 to 15 digits

  if (mandatoryCountryCode) {
    // Check if the phone number includes a valid country code
    if (cleanedPhone.startsWith('+')) {
      return phoneRegexWithCountryCode.test(cleanedPhone);
    } else {
      return false; // Country code is required, but it's not present
    }
  } else {
    // If country code is not mandatory, check both patterns (with or without country code)
    return phoneRegexWithCountryCode.test(cleanedPhone) || phoneRegexWithoutCountryCode.test(cleanedPhone);
  }
}

export function validateNumeric(input) {
  const reg = new RegExp('[0-9]*$');
  return reg.test(input);
}

export function validateURL(input) {
  const reg = new RegExp(
    '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$',
  );
  return reg.test(input);
}

export function validateIeltsScore(input) {
  const reg = new RegExp('^(?:\\d{0,1}\\.\\d{1,2})$|^\\d{0,1}$');
  return reg.test(input);
}

export function validateLinkedInURL(input) {
  const reg = new RegExp(
    '^(https:\\/\\/)?([a-z]{2,3}\\.)?linkedin\\.com\\/.*$',
  );
  return reg.test(input);
}

export function validate(block, input) {
  if (typeof block.dataType === 'undefined') return true;

  switch (block.dataType?.toUpperCase()) {
    case JobDataTypes.CLIENT_EMAIL:
    case CandidateDataTypes.EMAIL:
      return validateEmail(input);
    case JobDataTypes.CLIENT_PHONE:
    case CandidateDataTypes.PHONE:
    case CandidateDataTypes.VINCERE_EMERGENCY_PHONE:
      const phoneRequireCountryCode = block.options?.country_code_mandatory || false;
      return validatePhone(input, phoneRequireCountryCode);
    case CandidateDataTypes.CITY:
    case JobDataTypes.CITY:
    case CandidateDataTypes.STATE:
    case JobDataTypes.STATE:
    case CandidateDataTypes.COUNTRY:
    case JobDataTypes.COUNTRY:
      return isNaN(input) && input.length > 0;
    case JobDataTypes.REQUIRED_YEARS:
      return validateNumeric(input);
    case JobDataTypes.URL:
      return validateURL(input);
    case CandidateDataTypes.CANDIDATE_IELTS_SCORE:
      return validateIeltsScore(input);
    case CandidateDataTypes.LINKEDIN:
      return validateLinkedInURL(input);
    case CandidateDataTypes.FULL_NAME:
      return validateFullName(input);
    case CandidateDataTypes.VISA_NUMBER:
      return !isNaN(input);
    default:
      return input.length > 0;
  }
}
